<template>
  <div class="width-100-pr">
    <div class="sortable-item sortable-item-inputvideo">
      <span class="sortable-item-info">
        <span class="sortable-item-type">
          Video <span class="sortable-item-type-position">( {{ index + 1 }} )</span>
        </span>
        <span class="sortable-item-action sortable-item-move">
          <i class="far fa-arrows-alt"></i>
        </span>
        <a
          class="sortable-item-action sortable-item-delete"
          href="#"
          @click.prevent="deleteBlock"
        >
          <i class="far fa-trash-alt"></i>
        </a>
      </span>
      <div class="sortable-item-tag">
        <input
          name="video"
          :disabled="!canEdit"
          placeholder="Pega aquí la url de Youtube, Vimeo, Amazon o Bunny."
          type="text"
          value=""
          @keyup.prevent="insertVideo"
        />
        <small
          v-if="!isValidUrl"
          class="text-color-danger"
        >
          {{ messageError }}
        </small>
      </div>
    </div>
    <a
      class="sortable-text-info inputvideo-text"
      href="#"
      @click.prevent="$modal.showModal('MoleculeContentEditorModalAllowedUrl')"
    >Ver urls permitidas</a>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorBlockInputVideo',

  props: {
    block: Object,
    canEdit: {
      type: Boolean,
      default: true
    },
    index: Number,
    time: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      isValidUrl: true,
      messageError: ''
    }
  },

  methods: {
    deleteBlock () {
      if (this.canEdit) {
        this.$emit('deleteBlock', this.index)
      }
    },

    insertVideo (event) {
      let embedVideo = this.$utils.parseVideo(event.target.value)
      embedVideo
        ? this.$emit('insertVideo', embedVideo, event.target.value, this.index)
        : this.isValidUrl = false
    }
  }
}
</script>
